// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".Menu_root{display:block;padding:0;margin:0;box-sizing:border-box}\n", "",{"version":3,"sources":["webpack-internal:///./src/features/menu/molecules/footer-menu/Menu.sass"],"names":[],"mappings":"AAAA,WACE,aAAc,CACd,SAAU,CACV,QAAS,CACT,qBAAsB","file":"Menu.sass","sourcesContent":[".root {\n  display: block;\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box; }\n"]}]);
// Exports
exports.locals = {
	"root": "Menu_root"
};
module.exports = exports;
